import { Link } from "react-router-dom";
import type { Topic } from "@/mocks/topics";
import { categoryNameMap } from "@/mocks/topics";

interface TopicCardProps {
  topic: Topic;
  variant?: "default" | "horizontal";
  rank?: number;
}

export default function TopicCard({ topic, variant = "default", rank }: TopicCardProps) {
  if (variant === "horizontal") {
    return (
      <article className="group flex flex-col gap-4 border-b border-background-200 py-6 sm:flex-row sm:gap-6">
        {typeof rank === "number" && (
          <span className="font-heading text-2xl font-bold text-background-400 sm:w-10">
            {String(rank).padStart(2, "0")}
          </span>
        )}
        <div className="relative h-44 w-full shrink-0 overflow-hidden rounded-lg sm:h-28 sm:w-44">
          <img
            src={topic.cover}
            alt={topic.title}
            title={`${topic.title} - 看料档案深度专题`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-900">
              {categoryNameMap[topic.categoryId]}
            </span>
            <span className="whitespace-nowrap">{topic.date}</span>
            <span className="whitespace-nowrap">阅读 {topic.readTime} 分钟</span>
          </div>
          <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
            <Link to={`/topics/${topic.slug}`}>{topic.title}</Link>
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{topic.excerpt}</p>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
      <div className="relative h-48 w-full overflow-hidden">
        <img
          src={topic.cover}
          alt={topic.title}
          title={`${topic.title} - 看料档案深度专题`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-foreground-950/80 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
          {categoryNameMap[topic.categoryId]}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-heading text-lg font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          <Link to={`/topics/${topic.slug}`}>{topic.title}</Link>
        </h3>
        <p className="mt-3 line-clamp-3 flex-1 text-sm leading-7 text-foreground-600">
          {topic.excerpt}
        </p>
        <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
          <span className="truncate">{topic.author}</span>
          <span className="flex shrink-0 items-center gap-1 whitespace-nowrap">
            <i className="ri-fire-line text-primary-500" />
            热度 {(topic.hot / 1000).toFixed(1)}k
          </span>
        </div>
      </div>
    </article>
  );
}